




















import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseChevron from '@shared/components/@atoms/BaseChevron/BaseChevron.vue';
import { focus } from '@shared/ui/utilities/directives';
export default defineComponent({
  name: 'BaseFooterColumn',
  directives: { focus },
  components: {
    BaseChevron,
    BaseButton,
  },
  inject: ['items'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isColumnOpen: true,
    };
  },
  watch: {
    '$parent.isOpen': {
      handler(newVal) {
        this.isColumnOpen = newVal.includes(this.title);
      },
    },
  },
  created() {
    // @ts-ignore migrated from ui-library
    this.items.push(this.title);
  },
  methods: {
    // @ts-ignore migrated from ui-library
    toggle(payload) {
      // @ts-ignore migrated from ui-library
      this.$parent.toggle(payload);
    },
  },
});
